<template>
    <v-layout row wrap justify-center align-center my-2 class="container">
        <v-row no-gutters justify="center" align="center" class="mb-10 mt-n8">
          <v-col v-for="(transicion, index) in aTransiciones" :key="index" cols="10" class="text-center ma-1">
            <v-btn :id="`btn_transicion_${transicion}`" @click="GoTo(transicion)" large block dark color="btncolor" class="btn-primary btn-rounded">
              {{ transicion.replace(/_/g, ' ').toUpperCase() }} <v-icon size="20" right>mdi-cogs</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="10" class="text-center ma-1  pt-8" >
            <v-btn id="btn_CancelTransicion" @click="cancelar" large block dark color="error" class="btn-primary btn-rounded">
              Cancelar <v-icon size="20" right>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
    </v-layout>
</template>

<script>
import ModuloItem from "@/components/ModuloItem.vue"

export default {
  name: 'Transiciones',
  components: {
    ModuloItem
  },
  props: {
    aTransiciones: {
      type: Array,
      required: true,
      default: []
    }
  },
  data() {
    return {
    }
  },
  mounted() {

  },
  methods: {
    GoTo(sTansision_Select) {
      this.$emit('transicion', sTansision_Select)
    },
    cancelar() {
      this.$router.replace({
        name   : 'ProcesoDetalle', 
        params : { 
          idProceso: this.$route.params.idProceso,
          NombreProceso : this.$route.params.NombreProceso
        },
      })
    },
  },

}  
</script>

<style lang="scss" scoped>

.item-container{
  text-align: center;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin: 0 auto;
  padding: 10px;
  .cont-text{
    padding-left: 10px;
    text-align: left;
    align-content:left;
    .item-tittle{
      font-weight: 500;
      margin-bottom: 5px;
    }
    .item-button{
      width: auto;
      padding: 10px;
      border-radius: 4px;
      background-color:var(--v-primary-base);
      color: #FFF;
      line-height: 1.3em;
      font-size: 0.8em;
      text-transform: uppercase;
      font-weight: bolder;
      text-align: center;
      cursor: pointer;
    }
  }
}

</style>